export enum AbilityType {
  Speed = 'Speed',
  Gait = 'Gait',
  Temperament = 'Temperament'
}
